import React from 'react';

const LandscapeWarning = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 3000,
            color: 'white',
            padding: '20px',
            textAlign: 'center'
        }}>
            <div style={{
                fontSize: '80px',
                marginBottom: '30px',
                animation: 'rotate-icon 2s ease-in-out infinite'
            }}>
                📱
            </div>
            <h2 style={{
                margin: '0 0 16px 0',
                fontSize: '28px',
                fontWeight: '600'
            }}>
                Ruota il dispositivo
            </h2>
            <p style={{
                margin: 0,
                fontSize: '18px',
                opacity: 0.9,
                maxWidth: '400px'
            }}>
                La ricerca AI funziona meglio in modalità verticale
            </p>

            <style>{`
        @keyframes rotate-icon {
          0%, 100% {
            transform: rotate(90deg);
          }
          50% {
            transform: rotate(0deg);
          }
        }
      `}</style>
        </div>
    );
};

export default LandscapeWarning;